import { AfterViewInit, ChangeDetectorRef, ElementRef, HostListener, Injectable, Injector, NgZone, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuickSearch } from '../../autosearch';
import { FilterBadgeModel, FilterOption, FilterPropertyType, Operator } from '../../filter';
import { BaseQueovalItem, BreadDik, CustomgridModel, GQueovalDik, ParamApplication, QResult } from '../../models';
import { BreadcrumbService, CoreService, HttpService, qDragAndDropCallback, qDragAndDropConfig, qDragAndDropService } from '../../services';
import { ToastService } from '../../toast';
import { ConfigParam, PipeColumn, PipeDisplayMode, PipeGeneralPostModel, TreeveiwParam } from '../models/pipe.model';
import { BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject, Subscription } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CustomGridService } from '../../customgrid';

@Injectable()
export abstract class PipeBaseComponent implements OnInit, AfterViewInit, OnDestroy {
  public PipeDisplayMode = PipeDisplayMode;
  public treeveiwParam: TreeveiwParam;
  public configParam: ConfigParam = new ConfigParam();

  protected modalService: NgbModal;
  protected http: HttpService;
  protected indParam: CoreService;
  protected toast: ToastService;
  protected zone: NgZone;
  protected renderer: Renderer2;
  public dndService: qDragAndDropService;
  protected breadcrumb: BreadcrumbService;
  protected customgridservice: CustomGridService;
  protected cd: ChangeDetectorRef;

  //#region Constructor + Injector
  constructor(injector: Injector) {
    this.modalService = injector.get(NgbModal);
    this.http = injector.get(HttpService);
    this.indParam = injector.get(CoreService);
    this.toast = injector.get(ToastService);
    this.zone = injector.get(NgZone);
    this.renderer = injector.get(Renderer2);
    this.breadcrumb = injector.get(BreadcrumbService);
    this.customgridservice = injector.get(CustomGridService);
    this.dndService = new qDragAndDropService(this.zone, this.renderer);
    this.cd = injector.get(ChangeDetectorRef);

    this.getUrlParam();

    this.configParam.filter.modelGroup = this.treeveiwParam.filter;
    this.configParam.columnDefinition.columnFilterCode = this.treeveiwParam.filterCol;
    this.configParam.quickSearch.defaultOptionCode = this.treeveiwParam.quickSearch;
  }

  //#endregion

  ngOnInit(): void {

    if (this.configParam.gridModel)
      this.customgridservice.getItem().subscribe((res: any) => {
        this.gridClickCallBack(res);
      });


    if (this.configParam.filter.show) {
      this.buildFilter();
    } else {
      this.cardSubscription = this.getCards().subscribe(result => {
        if (this.configParam.displayMode == PipeDisplayMode.Pipe) {
          this.configParam.pipe.cardMockup = false;
          /* this.initPaginationListener();*/
        }
      });
    }
  }
  ngAfterViewInit() {
    this.afterBaseInit();

    if (this.treeveiwParam.quickSearch && this.configParam.quickSearch.data.length > 0) {
      this.configParam.quickSearch.data =  [...this.configParam.quickSearch.data.sort((a: QuickSearch, b: QuickSearch) => a.mode == this.treeveiwParam.quickSearch ? -1 : 1)];
    }

    this.cd.detectChanges();
  }
  protected afterBaseInit() { };


  private combineLastest: Subscription;

  ngOnDestroy(): void {
    if (this.columnModelList) {
      this.combineLastest.unsubscribe();
    }
  }

  private getUrlParam() {
    this.treeveiwParam = {
      filterCol: this.indParam.CurrentUrl.GetQueryParam('FILTERCOL') ? this.indParam.CurrentUrl.GetQueryParam('FILTERCOL') : '0',
      //PIPE|GRID
      displayMode: (this.indParam.CurrentUrl.GetQueryParam('MODE') == '' || this.indParam.CurrentUrl.GetQueryParam('MODE') == 'PIPE') ? PipeDisplayMode.Pipe : PipeDisplayMode.Grid,
      filter: this.indParam.CurrentUrl.GetQueryParam('FILTER'),
      model: this.indParam.CurrentUrl.GetQueryParam('MODEL'),
      quickSearch: this.indParam.CurrentUrl.GetQueryParam('QUICKSEARCH'),
      custumColumn: this.indParam.CurrentUrl.GetQueryParam('CUSTUMCOLUMN')
    }

    if (this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.model) {
      this.filterBadges = this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.model;
    }
    this.configParam.displayMode = this.treeveiwParam.displayMode;
  }

  public changeDisplayMode() {
    this.configParam.displayMode = this.configParam.displayMode == PipeDisplayMode.Pipe ? PipeDisplayMode.Grid : PipeDisplayMode.Pipe;

    if (this.configParam.displayMode == PipeDisplayMode.Pipe) {
      //this.gridConfigPipe.GridXml.rowData.data = null;
    } else {
      this.pipeColumns = new Array<PipeColumn>();
      this.configParam.pipe.pipeMockup = true;
      this.configParam.pipe.cardMockup = true;
    }
    this.getCards().pipe(first()).subscribe();
  }

  protected saveNavigationParam() {
    if (!this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0]) {
      this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params.push(new BreadDik('params', ''))
    }

    this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0].value = `MODE=${this.configParam.displayMode == PipeDisplayMode.Pipe ? 'PIPE' : 'GRID'}`;

    if (this.treeveiwParam.filterCol) {
      this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0].value += `&FILTERCOL=${this.treeveiwParam.filterCol}`;
    }
    if (this.treeveiwParam.custumColumn) {
      this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0].value += `&CUSTUMCOLUMN=${this.treeveiwParam.custumColumn}`;
    }

    if (this.treeveiwParam.filter) {
      this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0].value += `&FILTER=${this.treeveiwParam.filter}`;
    }

    if (this.treeveiwParam.quickSearch) {
      this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.params[0].value += `&QUICKSEARCH=${this.treeveiwParam.quickSearch}`;
    }

  }

  //#region Structure pipe
  @ViewChildren('ScrollViewport') viewPorts: QueryList<CdkVirtualScrollViewport>;
  public pipeColumns: Array<PipeColumn> = new Array<PipeColumn>();

  private getColumn(): Observable<Array<PipeColumn>> {
    if (this.pipeColumns.length > 0) {
      return of(this.pipeColumns);
    }

    this.configParam.columnDefinition.columnFilterCode = this.treeveiwParam.filterCol;
    return this.http.postHttp<QResult<Array<PipeColumn>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_COLUMN`, this.configParam.columnDefinition).pipe(
      mergeMap((result: QResult<Array<PipeColumn>>) => {
        if (!result.HasError) {
          this.configParam.pipe.pipeMockup = false;
        }
        return of(result.Value);
      }));
  }

  protected getCustomColumn(): Observable<QResult<Array<PipeColumn>>> {
    return of(new QResult<Array<PipeColumn>>());
  }

  protected getCards(): Observable<boolean> {
    this.beforeGetCards();
    if (this.configParam.displayMode == PipeDisplayMode.Pipe) {
      return this.getColumn().pipe(
        mergeMap((column: Array<PipeColumn>) => {
          this.pipeColumns = column;
          let callArray: Array<Observable<QResult<PipeColumn>>> = new Array<any>();

          //recuperation des cartes pour chaque colonnes
          column.forEach((col: PipeColumn) => {
            let model: PipeGeneralPostModel = new PipeGeneralPostModel();
            model.columnDefinition = this.configParam.columnDefinition;
            model.filterBadges = this.filterBadges;

            model.column = new PipeColumn(col)
            model.column.pagination.currentPage = 0;
            model.column.pagination.getPagination = true;

            col.cards = new Array<any>();
            callArray.push(this.http.postHttp<QResult<PipeColumn>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/CARD_PAGINATION`, model))
          });
          return forkJoin(callArray).pipe(mergeMap((result: QResult<PipeColumn>[]) => {
            let newCol = Array<PipeColumn>();
            for (let i = 0; i < result.length; i++) {
              if (result[i].Value.cards?.length) {
                const columnId = this.pipeColumns.findIndex(col => { return JSON.stringify(col.columnSelector) == JSON.stringify(result[i].Value.columnSelector) });
                this.pipeColumns[columnId] = result[i].Value;
                newCol.push(this.pipeColumns[columnId]);
              }
            }
            this.configParam.pipe.cardMockup = false;
            this.initPaginationListener();
            this.initDragAndDrop();
            this.afterGetCardsPipe(newCol);
            return of(true);
          }))
        }));
    } else {

      this.gridLoaded = false;
      this.gridReady$.next(false);
      let model: PipeGeneralPostModel = new PipeGeneralPostModel();
      model.columnDefinition = this.configParam.columnDefinition;
      model.filterBadges = this.filterBadges;
      model.gridName = this.configParam.gridModel;
      return this.http.postHttp<QResult<Array<String>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/CARD_IDENT/`, model).pipe(mergeMap(result => {
        this.gridWhere = result.Value.length > 0 ? `${this.configParam.columnDefinition.tablePrefix}.Ident in (${result.Value.join(',')})` : `${this.configParam.columnDefinition.tablePrefix}.Ident = '-1' `;
        this.gridLoaded = true;
        
          this.combineLastest = combineLatest([this.afterCardGrid$, this.gridReady$]).subscribe((x: any) => {
            if (x[1]) {
              this.afterGetCardsGrid(result.Value);
            }
          })
        this.afterCardGrid$.next();
        return of(true);
      }));
    }
  }
  protected beforeGetCards() { }
  protected afterGetCardsPipe(columns: Array<PipeColumn> | undefined = undefined) { }
  protected afterGetCardsGrid(filtredIdent: String[] | undefined = undefined) { }

  private initPaginationListener() {
    setTimeout(() => {
      this.viewPorts?.forEach((virtualScroll: CdkVirtualScrollViewport) => {
        let vssub = virtualScroll.elementScrolled().subscribe((event: any) => {
          let scroll = this.viewPorts.toArray()[parseInt(event.target.dataset.columns)];
          if (scroll.getRenderedRange().end === scroll.getDataLength() &&
            !this.pipeColumns[parseInt(event.target.dataset.columns)].pagination.paginationLoading
            && scroll.getRenderedRange().end != this.pipeColumns[parseInt(event.target.dataset.columns)].pagination.nbElement) {
            this.pipeColumns[parseInt(event.target.dataset.columns)].pagination.getPagination = false;
            this.loadPagination(this.pipeColumns[parseInt(event.target.dataset.columns)]);
          }
        });
      })
        , 1
    });
  }

  private loadPagination(column: PipeColumn): void {
    column.pagination.paginationLoading = true;
    column.pagination.currentPage++;
    column.pagination.getPagination = false;

    let model: PipeGeneralPostModel = new PipeGeneralPostModel();
    model.columnDefinition = this.configParam.columnDefinition;
    model.filterBadges = this.filterBadges;
    model.column = new PipeColumn(column);

    this.http.postHttp<QResult<PipeColumn>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/CARD_PAGINATION`, model).subscribe((result: QResult<PipeColumn>) => {
      this.zone.run(() => {
        column.cards = column.cards.concat(result.Value.cards);
        column.pagination.paginationLoading = false;
        this.afterGetCardsPipe([column]);
        this.cd.markForCheck();
      });
    });
  }

  //#region Renommer colonne
  public changeColumnName(column: PipeColumn) {

    let postData = new PipeGeneralPostModel();
    postData.column = column;
    postData.columnDefinition = this.configParam.columnDefinition;


    this.http.postHttp<QResult<number>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/RENAME_COLUMN`, postData).subscribe((result: QResult<number>) => {
      column.isEditMode = false;
    });
  }
  //#endregion
  //#region Creation nouvelle colonne
  public newColToggle: boolean = false;
  public newColName: string;

  public toggleNewCol(state: boolean) {
    this.newColName = '';
    this.newColToggle = state;
  }

  public createNewCol() {
    if (!this.newColName) {
      this.toast.showWarningToast("Veuillez saisir un nom de colonne valide");
      return;
    }

    let postData = new PipeGeneralPostModel();
    postData.columnDefinition = this.configParam.columnDefinition;
    postData.newColumnName = this.newColName;

    this.http.postHttp<QResult<PipeColumn>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/CREATE_NEW_COLUMN`, postData).subscribe((result: QResult<PipeColumn>) => {
      this.toggleNewCol(false);
      if (!result.HasError) {
        this.pipeColumns.push(result.Value);
        this.pipeColumns.sort((a: PipeColumn, b: PipeColumn) => { return (+!getTypecolumn(a) - +!getTypecolumn(b)) + +(parseInt(getTypecolumn(a)) > parseInt(getTypecolumn(b))) + -(parseInt(getTypecolumn(a)) < parseInt(getTypecolumn(b))) })
        function getTypecolumn(pipeColumn: PipeColumn): string {
          return pipeColumn.columnSelector[0].PropValue;
        }
      }
    });
  }
  //#endregion
  //#endregion

  //#region Drag and drop
  //@ViewChild('pipeColumnContainer', { static: false }) pipeColumnContainer: ElementRef;

  @HostListener('window:mouseup', ['$event'])
  mouseUp(event: any) {
    this.dndService.onMouseUpWindows(event);
  }

  private initDragAndDrop() {
    //Init du drag n drop des cartes du pipe
    if (this.dndService.dndConfig == undefined) {
      this.dndService.dndConfig = new qDragAndDropConfig();
      this.dndService.dndConfig.colObj = this.pipeColumns;
      this.dndService.dndConfig.cardObjName = 'cards';
      this.dndService.dndConfig.autoBindingEvent = true;
      this.dndService.initDnD();

      /* this.dndService.dndConfig.wrapperElement: this.pipeColumnContainer;
       };*/

      //Callback Drag n Drop : DROP
      this.dndService.callbackDrop$.subscribe((data: qDragAndDropCallback) => {
        if (data.oldColId != data.newColId) {
          this.dropCallBack(data);
        }
      });

      //Callback Drag n Drop : CLICK
      this.dndService.callbackClick$.subscribe((data: qDragAndDropCallback) => {
        this.cardClickCallBack(data);
      });
    }
  }

  protected cardClickCallBack(data: qDragAndDropCallback) {
    throw new Error('Method not implemented.');
  }

  protected dropCallBack(data: qDragAndDropCallback) {
    const card: any = this.pipeColumns[data.newColId].cards[data.newCardId];
    this.pipeColumns[data.newColId].cards.pop();

    let postData = new PipeGeneralPostModel();
    postData.filterBadges = this.filterBadges;
    postData.column = new PipeColumn(this.pipeColumns[data.newColId])
    postData.columnDefinition = this.configParam.columnDefinition;
    postData.cardIdent = data.ident;

    this.http.postHttp<QResult<number>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Filtered/UPDATE_STAGE_COLONNE_DND`, postData).subscribe((result: QResult<number>) => {
      if (result.Value >= 0) {
        this.pipeColumns[data.newColId].cards.splice(result.Value, 0, card);
        this.pipeColumns[data.newColId].pagination.stepOffset++;
      }

      this.pipeColumns[data.newColId].pagination.nbElement++;
      this.pipeColumns[data.newColId].pagination.nbPage = Math.ceil(this.pipeColumns[data.newColId].pagination.nbElement / this.pipeColumns[data.newColId].pagination.step);

      this.pipeColumns[data.oldColId].pagination.nbElement--;
      this.pipeColumns[data.oldColId].pagination.nbPage = Math.ceil(this.pipeColumns[data.oldColId].pagination.nbElement / this.pipeColumns[data.oldColId].pagination.step);
      this.pipeColumns[data.oldColId].pagination.stepOffset--;

      this.zone.run(() => {
        this.pipeColumns[data.newColId].cards = [...this.pipeColumns[data.newColId].cards];
        this.pipeColumns[data.oldColId].cards = [...this.pipeColumns[data.oldColId].cards];
      });

      if (this.pipeColumns[data.oldColId].cards.length < 8
        && !this.pipeColumns[data.oldColId].pagination.paginationLoading
        && this.pipeColumns[data.oldColId].cards.length != this.pipeColumns[data.oldColId].pagination.nbElement) {
        this.loadPagination(this.pipeColumns[data.oldColId]);
      }

      this.afterDropCallBack(data);
    });
  }

  protected afterDropCallBack(data: qDragAndDropCallback) { }
  //#endregion

  //#region GRID
  public gridLoaded: boolean;
  public gridConfigPipe: CustomgridModel;
  public gridWhere: string;
  protected gridUpdateValue: any;

  public gridReady$ = new BehaviorSubject<boolean>(false);
  public afterCardGrid$ = new Subject<void>();

  public gridReady(e: any) {
    this.gridReady$.next(true);
  }

  protected gridClickCallBack(res: any) {
  }
  //#endregion

  //#region Filter
  protected cardSubscription: Subscription = new Subscription();

  public filterBadges: Array<FilterBadgeModel>
  public filterOption: FilterOption = new FilterOption();

  public onFilterChange(event: Array<FilterBadgeModel>) {
    this.configParam.pipe.cardMockup = true;
    if (!this.cardSubscription.closed) {
      this.cardSubscription.unsubscribe();
    }

    this.cardSubscription = this.getCards().subscribe(result => {
      if (this.configParam.displayMode == PipeDisplayMode.Pipe) {
        this.configParam.pipe.cardMockup = false;
        this.initPaginationListener();
      }
    });
    this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.model = this.filterBadges;
  }

  public filterBtnClick(event: any) { throw new Error("not Implemented") }
  //#endregion

  //#region Quick search
  public quickSearch(badges: Array<FilterBadgeModel>) {
    // Suppression des badges de l'ancien mode
    this.filterBadges = this.filterBadges.filter((badge: FilterBadgeModel) => !(badge.PropType == FilterPropertyType.QuickSearch));
    if (badges.length > 0) {
      badges.map(b => { b.PropKey = badges[0].PropKey });
    }
    this.filterBadges = [...this.filterBadges, ...badges]



    // lancement de la recherche avec les nouveaux badge    
    this.onFilterChange(this.filterBadges);
  }

  protected getQuickSearchPropKey(mode: string): string {
    throw new Error("not Implemented")
  }
  //#endregion

  //#region Gestion des colonnes
 
  columnList: Array<BaseQueovalItem>;
  selectedColumn: Array<string> = new Array<string>();
  columnModelList: Array<ParamApplication>;
  currentColumnModel: ParamApplication = new ParamApplication();


  public checkColumnModel(columnCode: string) {
    if (this.selectedColumn.some(e => e == columnCode)) {
      this.selectedColumn = this.selectedColumn.filter(e => e != columnCode);
    } else {
      this.selectedColumn.push(columnCode);
    }
  }

  public selectColumnModel(model: ParamApplication | null) {
    if (model) {
      this.currentColumnModel = model;
      this.selectedColumn = this.currentColumnModel.StrValue.split(',');
    } else {
      this.currentColumnModel = new ParamApplication();
      this.selectedColumn = new Array<string>();
    }
  }

  public saveColumnModel() {
    let error = false;
    if (!this.currentColumnModel.Info) {
      error = true;
      this.toast.showAlertToast("Le modèle a besoin d'un titre");
    }
    if (this.selectedColumn.length == 0) {
      error = true;
      this.toast.showAlertToast("Aucune colonne selectionée");
    }

    if (error) return;

    this.currentColumnModel.StrValue = this.selectedColumn.join(',');
    this.currentColumnModel.Group = this.configParam.columnDefinition.columnFilterGroupe;
    let update: boolean = this.currentColumnModel.Code ? true : false;
    this.http.postHttp<QResult<ParamApplication>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}SaveColumnModel`, this.currentColumnModel).subscribe((res: QResult<ParamApplication>) => {
      if (update) {
        this.columnModelList[this.columnModelList.findIndex(e => e.Code == res.Value.Code)] = res.Value;
      } else {
        this.columnModelList.push(res.Value);
      }
      this.currentColumnModel = res.Value;
    });
  }

  public deleteColumnModel() {
    this.http.postHttp<QResult<ParamApplication>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}DeleteColumnModel`, this.currentColumnModel).subscribe((res: QResult<ParamApplication>) => {
      this.columnModelList = this.columnModelList.filter(e => e.Code != res.Value.Code);
      this.currentColumnModel = new ParamApplication();
      this.selectedColumn = new Array<string>();
    });
  }

  public addToClipboard() {
    const el = document.createElement('textarea');
    el.value = `'FILTERCOL=${this.currentColumnModel.Code}'`;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    // }
    this.toast.showInfoToast("Code copié dans le presse papier");
  }
  //#endregion

  protected buildFilter() {
    if (this.configParam.filter.show) {

      //Recuperation du model par defaut dans le treeveiw
      this.configParam.filter.modelCode = this.indParam.CurrentUrl.GetQueryParam('MODEL');


      //Recuperation des filters dans le treeveiw
      if (this.treeveiwParam.filter) {
        if (!this.filterBadges) {
          this.filterBadges = new Array<FilterBadgeModel>
        } else {
          this.filterBadges = this.filterBadges.filter(e => !e.Treeview);
        }

        const splitedFilter = this.treeveiwParam.filter.split(';');
        for (let i = 0; i < splitedFilter.length; i += 2) {
          if (i + 1 == splitedFilter.length) break;

          const propKey = splitedFilter[i];
          const propValue = splitedFilter[i + 1];
          this.filterBadges.push({ PropKey: propKey, PropValue: propValue, PropOperator: Operator.Egale, PropType: FilterPropertyType.Select, PropInWhere: true, Order: 0, Text: '', Value: '', Hidden: true, Treeview: true })
        }

        this.breadcrumb.Breadcrumb[this.breadcrumb.Breadcrumb.length - 1].data.model = this.filterBadges;
      }

      this.http.getHttp<QResult<FilterOption>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}GET_FILTRE/0`).subscribe((result: QResult<FilterOption>) => {
        this.filterOption = result.Value;
      });
    }
  }

}
